
function buttonKeyDownHandler(event) {
    if (event.code === 'Enter' || event.code === 'Space') {
        event.preventDefault();
        event.stopPropagation();
        event.target.click();
    }
}

export default buttonKeyDownHandler;
